export const transformToCustomerInfo = (detail?: object) => {
    const infoList = Object.entries(detail || {}).map(([key, value]) => {
        return {
            key,
            value,
        };
    });

    return infoList;
};
